export const extensionCheck=(fileName)=>{
    var allowedExtensions =/(\.csv)$/i;
    if (allowedExtensions.exec(fileName)){
        return true;
    }
    else{
        return false;
    }
}